<template>
  <div class="manage-main-box">
    <Bread :breadConfig="breadConfig" />
    <div class="eol-container-box">
      <div class="search-all-box">
        <a-form-model layout="inline" ref="ruleForm" :model="form">
          <a-form-model-item prop="name">
            <a-input v-model="form.name" class="search-input" placeholder="请输入线上展厅名称"></a-input>
          </a-form-model-item>
          <a-form-model-item>
            <a-button class="search-btn" type="primary" @click="onSearch()">搜索</a-button>
            <a-button class="reset-btn" @click="resetForm()">重置</a-button>
          </a-form-model-item>
        </a-form-model>
        <div class="right-option-box">
          <a-button class="option-btn" type="primary" @click="addStadium()">添加线上展厅</a-button>
        </div>
      </div>
      <div class="table-all-box">
        <a-table :columns="columns" :data-source="tableData" rowKey="id" :bordered="false" size="small" :pagination="false">
          <template slot="action" slot-scope="text, scope">
            <a-button type="link" @click="setStudentModal(scope)">编辑</a-button>
            <a-button type="link" @click="deleteStudentModal(scope)">删除</a-button>
          </template>
        </a-table>
        <a-pagination class="school-pagination" v-model="page" :total="totalNum" @change="pageChange" show-less-items />
      </div>
      <CommonModal v-model="showDeleteModal" title="删除线上展厅" confirmText="确定" @confirm="handleDeleteConfirm">
        <div class="delete-modal">
          确定删除线上展厅吗？
        </div>
      </CommonModal>
      <addShowroom v-model="showAddModal" :venue_id="venue_id" :hallId="hallId" :title="setModelText" confirmText="确定" @confirm="handaddedConfirm"></addShowroom>
    </div>
  </div>

</template>
<script>
import CommonModal from "../../../../components/CommonModal"
import addShowroom from "../../../../components/school/addShowroom.vue"
import { mapActions,mapState } from "vuex";
// import services from '../../../../assets/js/services';
import Bread from "../../../../components/school/Bread.vue";
export default {
  name: 'artifactAddress',
  components: {
    CommonModal,
    addShowroom,
    Bread
  },
  data() {
    return {
      breadConfig: [{ name: "场馆旧址" },{ name: "线上展厅" }],
      school_code: localStorage.getItem("schoolCode"),
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      venue_id:"",
      form: {
        name: "",
        
      },
     
      stadiumType: [],
      columns: [
        {
          title: "线上展厅名称",
          dataIndex: "name",
        },
        {
          title: "更新时间",
          dataIndex: "updated_at",
        },
        {
          title: "更新人",
          dataIndex: "updated_name",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
      showDeleteModal: false,
      showAddModal: false,
      setModelText: '添加',
      hallId: "",
      deleteId: "",
    };
  },

  mounted() {
        if (!(this.appsUserInfo.user_type == 2 || (this.appsUserInfo.user_type == 1 && this.appsUserInfo.role_ids == 2))) {
      this.$router.push(`/${this.school_code}/school/teach`)
    }
    this.venue_id = this.$route.query.venue_id
    this.getTableList()
  },
    computed: {
    ...mapState({
      appsUserInfo: state => state.appsLogin.appsUserInfo,
    }),
  },
  watch: {
    showAddModal: {
      handler(newVal) {
        if (!newVal) {
          this.hallId = ""
        }
      }
    }
  },
  methods: {
    ...mapActions(["getHall", "editHall", "addHall", "getHallInfo"]),
    getTableList() {
      let params = {
        page: this.page,
        size: this.size,
        name: this.form.name,
        venue_id: this.venue_id,
      };
      this.getHall(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
          // console.log(res.data)
        }
      });
    },
    onSearch() {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    pageChange(val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.onSearch()
    },
    handleModalVisible(key, val) {
      this[key] = val
    },
    handleDeleteConfirm() {
      this.studentDelete({ id: this.deleteId, data: { venue_id: this.venue_id, _method: 'delete' } })
    },
    handaddedConfirm() {
      this.getTableList()
    },
    setStudentModal(item) {
      this.hallId = item.id
      this.setModelText = '编辑线上展厅'
      this.handleModalVisible('showAddModal', true)

    },

    addStadium() {
      this.setModelText = '添加线上展厅'
      this.handleModalVisible('showAddModal', true, null)
    },

    // 表格中 删除按钮 点击事件
    deleteStudentModal(item) {
      this.deleteId = item.id
      this.delType = 1
      this.handleModalVisible('showDeleteModal', true)
    },
    // 班级添加和删除方法
    studentDelete(params) {
      this.editHall(params).then(res => {
        if (res.code == "0000") {
          this.studentId = ''
          this.$message.success(`删除成功`)
          this.handleModalVisible('showDeleteModal', false)
          this.resetForm()
        } else {
          this.$message.error(res.message)
        }
      })
    },



  },
};
</script>

<style lang="less" scoped>
.back-class-btn {
  padding: 0 16px;
  height: 32px;
  background: #b84b3c;
  border-radius: 16px;
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 15px;
  line-height: 32px;
  &:hover {
    background: #a82822;
  }
}
.delete-modal {
  font-weight: bold;
  font-size: 16px;
  color: #373536;
  text-align: center;
}
.choose-modal {
  padding-top: 20px;
}
</style>